import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import HideConfirmation from './HideConfirmation';
import DeleteConfirmation from './DeleteConfirmation';
import ExpireConfirmation from './ExpireConfirmation';
import ReactivateCoupon from './ReactivateCoupon';

function Modal() {
    const [visible, setVisible] = useState(false);

    const activeListModal = useSelector((state) => state.coupons.listModal.activeListModal);
    const displayListModal = useSelector((state) => state.coupons.listModal.displayListModal);

    useEffect(() => {
        if(displayListModal) {
            setVisible(true);
        } else {
            setVisible(false);
        }
    }, [displayListModal]);

    return (
        <div className={`${visible ? 'opacity-100 visible bg-[#00000080]' : 'opacity-0 invisible'} transition-all duration-100 ease-in-out fixed z-50 size-full top-0 left-0 flex justify-center items-center`}>
            {activeListModal === 'delete-confirm' && <DeleteConfirmation />}

            {activeListModal === 'hide-confirm' && <HideConfirmation />}

            {activeListModal === 'expire-confirm' && <ExpireConfirmation />}

            {activeListModal === 'reactivate-coupon' && <ReactivateCoupon />}
        </div>
    );
}

export default Modal;
